import consumer from "./consumer"
$(document).on('turbolinks:load', function () {
  var id = $(".channelid").attr("id");
  var memberid = $(".memberid").attr("id");
  if (typeof id !== 'undefined' && id !== false) {
    consumer.subscriptions.create({channel: "RalliesChannel", id: id}, {
      connected() {
        if (typeof memberid !== 'undefined' && memberid !== false) {
          $('.textdetails').append('<p>You are connected.</p>');

          $.ajax({
            url: "/rally/links/connected", 
            dataType: "script",
            type: "POST",
            headers: { 'X-CSRF-Token': $("#authenticity_token").val() },
            data: "id="+$(".memberid").attr("id")+"&allid="+id,
            success: function(result){
            }
          });
        }
        
        // Called when the subscription is ready for use on the server
      },

      disconnected() {
        if (typeof memberid !== 'undefined' && memberid !== false) {
          $.ajax({
            url: "/rally/links/disconnect", 
            dataType: "script",
            type: "POST",
            headers: { 'X-CSRF-Token': $("#authenticity_token").val() },
            data: "id="+$(".memberid").attr("id")+"&allid="+id,
            success: function(result){
            }
          });
          $('.textdetails').html('<p>You are disconnected.</p>');
        }
      },

      received(data) {

        if (typeof data.connected !== 'undefined' && data.connected !== false) {
          $("#connected"+data.connected).html('<i style="color:green;" class="fa fa-check" aria-hidden="true"></i>');
        }
        if (typeof data.soundtest !== 'undefined' && data.soundtest !== false) {
          $("#soundtest"+data.soundtest).html('<i style="color:green;" class="fa fa-check" aria-hidden="true"></i>');
        }

        if (typeof data.disconnected !== 'undefined' && data.disconnected !== false) {
          $("#connected"+data.disconnected).html('<i style="color:red;" class="fa fa-times" aria-hidden="true"></i>');
          $("#soundtest"+data.disconnected).html('<i style="color:red;" class="fa fa-times" aria-hidden="true"></i>');
        }

        if (typeof data.nexttarget !== 'undefined') {
          $('.textdetails').html('<div style="width:100%;"><div style="border:1px solid black;width:100%;" class="text-center"><div class="row"><div style="width:15%;"><button id="mother" type="button" class="btn btn-sm btn-danger"></button></div><div style="width:15%;"></div><div style="width:15%;"><button id="topstronghold" type="button" class="btn btn-sm btn-danger"></button></div><div style="width:7.5%;"></div><div style="width:15%;"><button id="topoutpost" type="button" class="btn btn-sm btn-danger"></button></div><div style="width:7.5%;"></div><div style="width:15%;"><button type="button" class="btn btn-lg btn-info">  </button></div></div><div class="row"></div><div class="row"><div style="width:75%;"></div><div style="width:15%;"><button id="topport" type="button" class="btn btn-sm btn-danger"></button></div><div style="width:7.5%;"></div></div><div class="row"></div><div class="row"><div style="width:7.5%;"></div><div style="width:15%;"><button id="leftmine" type="button" class="btn btn-sm btn-danger"></button></div><div style="width:15%;"></div><div style="width:15%;"><button id="cr" type="button" class="btn btn-sm btn-danger"></button></div><div style="width:15%;"></div><div style="width:15%;"><button id="rightmine" type="button" class="btn btn-sm btn-danger"></button></div><div style="width:7.5%;"></div></div><div class="row"></div><div class="row"><div style="width:7.5%;"></div><div style="width:15%;"><button id="botport" type="button" class="btn btn-sm btn-danger"></button></div><div style="width:75%;"></div></div><div class="row"></div><div class="row"><div style="width:7.5%;"><button type="button" style="margin-left:20px;" class="btn btn-lg btn-info">  </button></div><div style="width:7.5%;"></div><div style="width:15%;"><button id="botoutpost" type="button" class="btn btn-sm btn-danger"></button></div><div style="width:7.5%;"></div><div style="width:15%;"><button id="botstronghold" type="button" class="btn btn-sm btn-danger"></button></div><div style="width:22.5%;"></div><div style="width:15%;"><button id="warrior" type="button" class="btn btn-sm btn-danger"></button></div></div></div>');
          $("#"+data.nexttarget).removeClass("btn-danger").addClass("btn-success");
        }

        if (typeof data.notarget !== 'undefined') {
          $('.textdetails').html('No target');
        }
        

    
        if (data.content == "pingall") {
          $(".textdetails").html('<p style="color:green;">EVERYONE Send!</p>');
          audio.play();
        }
        if (data.content == "speedall") {
          $(".textdetails").html('<p style="color:green;">EVERYONE speed up!</p>');
          speedaudio.play();
        }
        
      }
    });
  }
});